/* k4k-float.js (batch 1, preview): keeps floating UI tidy. Styling/layout only, no consent or app logic is changed.
   - measures the cookie card and the Shopify preview bar (preview only) and exposes --k4k-cookie-h, --k4k-pbar-h, --k4k-lift, --k4k-chat-lift
   - tidies the BSS "wholesale" bar wording and the price-match pill (made a fixed bottom-left card on all widths (the app shows it as a top banner on phones))
   Delete this file and its <script> in layout/theme.liquid to revert. */
(function(){
  var root=document.documentElement, mq=window.matchMedia('(max-width: 1099px)'), mob=window.matchMedia('(max-width: 749px)');
  function rect(el){if(!el)return 0;var cs=getComputedStyle(el);if(cs.display==='none'||cs.visibility==='hidden')return 0;return el.getBoundingClientRect().height||0}
  function measure(){
    var ch=rect(document.getElementById('shopify-pc__banner')), ph=rect(document.getElementById('PBarNextFrameWrapper'));
    var lift=ch?Math.round(ch+10+8):0;
    root.style.setProperty('--k4k-cookie-h',Math.round(ch)+'px');
    root.style.setProperty('--k4k-pbar-h',Math.round(ph)+'px');
    root.style.setProperty('--k4k-lift',lift+'px');
    root.style.setProperty('--k4k-chat-lift',(mq.matches?lift:0)+'px');
    root.classList.toggle('k4k-cookie-open',!!ch);
  }
  var WHOLESALE_MOBILE='For wholesale or international shipping costs, click here';
  function tidyBar(){
    var a=document.querySelector('.bss-pl-banner');
    if(a&&!a.dataset.k4k){a.dataset.k4k='1';
      a.setAttribute('aria-label','Wholesale or international enquiries: contact us');
      a.textContent=WHOLESALE_MOBILE;}
    var c=document.querySelector('.bss-pl-banner-wrapper .close-banner');
    if(c&&!c.dataset.k4k){c.dataset.k4k='1';c.setAttribute('role','button');c.setAttribute('aria-label','Dismiss this message');c.setAttribute('tabindex','0');c.textContent='\u00d7';
      c.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();c.click()}});}
  }
  var pillTimer=null;
  function tidyPill(){
    var p=document.querySelector('[id^="bss-popup-"]');
    if(!p||p.dataset.k4k)return; p.dataset.k4k='1'; p.classList.add('k4k-pm');
    var h=p.querySelector('h4'), t=p.querySelector('p'), x=p.querySelector('.close');
    if(h) h.textContent='Price match';
    if(t) t.textContent='Price match on our cleaning chemicals. Found these products cheaper elsewhere? Let us know before you order.';
    if(x){x.setAttribute('role','button');x.setAttribute('aria-label','Dismiss price match message');x.setAttribute('tabindex','0');x.textContent='\u00d7';
      x.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();x.click()}});}
    p.addEventListener('mouseenter',function(){p.classList.remove('k4k-pm--min')});
    p.addEventListener('focusin',function(){p.classList.remove('k4k-pm--min')});
    p.addEventListener('mouseleave',function(){p.classList.add('k4k-pm--min')});
    pillTimer=setTimeout(collapse,6000);
    var l=p.querySelector('a[href]'); if(l){l.setAttribute('href','/pages/price-match-promise');l.removeAttribute('target');l.removeAttribute('rel');l.setAttribute('aria-label','Price match promise: read the terms');}
  }
  function collapse(){var p=document.querySelector('[id^="bss-popup-"].k4k-pm');if(p&&!p.matches(':hover')&&!p.contains(document.activeElement))p.classList.add('k4k-pm--min')}
  function tick(){tidyBar();tidyPill();measure()}
  function init(){
    tick();
    if(window.MutationObserver)new MutationObserver(tick).observe(document.body,{childList:true,subtree:false});
    if(window.ResizeObserver){var ro=new ResizeObserver(measure);var w=setInterval(function(){var b=document.getElementById('shopify-pc__banner'),p=document.getElementById('PBarNextFrameWrapper');if(b)ro.observe(b);if(p)ro.observe(p);},800);setTimeout(function(){clearInterval(w)},15000)}
    window.addEventListener('resize',measure);
    var n=0,t=setInterval(function(){tick();if(++n>40)clearInterval(t)},500);
    document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('#shopify-pc__banner'))setTimeout(measure,150)},true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
